type Args = {
  localStorageKey?: 'mugen.debug.useEffect' | 'mugen.debug.layout';
};

export function debugClient({ localStorageKey }: Args) {
  if (process.env.NEXT_PUBLIC_IS_DEBUGGING_ENABLED !== 'true') {
    return;
  }

  if (typeof window !== 'undefined' && localStorageKey && window.localStorage.getItem(localStorageKey) === 'true') {
    console.error(`debug:${localStorageKey}:`);
    throw new Error(`debug:${localStorageKey}`);
  }
}
